import React from 'react';
import { Leaf, Heart, Award, Recycle } from 'lucide-react';
import './About.css';
import { aboutUs } from '../mockData';

const valueIcons = {
  'Freshness': Leaf,
  'Health': Heart,
  'Purity': Award,
  'Sustainability': Recycle
};

const About = () => {
  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="section-header">
          <h2 className="heading-2">{aboutUs.title}</h2>
        </div>
        <div className="about-content">
          <p className="body-large about-text">{aboutUs.content}</p>
          
          <div className="values-grid">
            {aboutUs.values.map((value, index) => {
              const Icon = valueIcons[value.title];
              return (
                <div key={index} className="value-card">
                  <div className="value-icon">
                    <Icon size={28} strokeWidth={1.5} />
                  </div>
                  <div className="value-content">
                    <h4 className="value-title">{value.title}</h4>
                    <p className="body-small">{value.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
